import React, { useState, useRef, useEffect } from "react";
import styles from "./styles/birthdayPage.module.css";
import Navbar from "../component/navbar/Navbar";
import Banner from "../component/banner/Banner";
import birthBanner from "../assets/images/birthBanner.png";
import lineLB from "../assets/images/lineLB.png";
import lineRB from "../assets/images/lineRB.png";
import Footer from "../component/footer/Footer";

const BirthdayPage = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const titleRef = useRef(null);
  const requestRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      requestRef.current = requestAnimationFrame(() => {
        const titleTop = titleRef.current.offsetTop;
        const titleHeight = titleRef.current.offsetHeight;
        const scrollTop = window.scrollY;
        const scrollBottom = scrollTop + window.innerHeight;

        // check if the title is in view
        if (scrollTop < titleTop + titleHeight && scrollBottom > titleTop) {
          const progress =
            (scrollBottom - titleTop) / (titleHeight + window.innerHeight);
          setScrollPosition(progress);
        } else {
          setScrollPosition(0);
        }
      });
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      cancelAnimationFrame(requestRef.current);
    };
  }, []);

  const titleStyle = {
    background: `linear-gradient(to left, #5618C5 ${
      scrollPosition * 180
    }%, transparent 0)`,
  };

  return (
    <>
      <div>
        <div>
          <Navbar />
        </div>
        <div className={styles.contant}>
          <Banner bannerImage={birthBanner} />
        </div>
        <div className={styles.containerTitle}>
          <img className={styles.lineFront} src={lineRB} alt="lineR" />
          <div className={styles.titleBackground}>
            <h1 ref={titleRef} style={titleStyle} className={styles.titleText}>
              {" "}
              تولد در هلیوم پارک
            </h1>
          </div>
          <img className={styles.lineFront} src={lineLB} alt="lineL" />
        </div>
        <div className={styles.textContainerUp}>
          <p className={styles.text}>
            جشن تولد یا دورهمی‌تون رو درهلیوم پارک برگزار کنید و یک خاطره فراموش
            نشدنی و خوش بسازید.
          </p>
        </div>
        <div className={styles.videoContainer}>
          <video className={styles.videoplayer} controls autoPlay={true}>
            <source
              src="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/tavalod.m4v"
              type="video/mp4"
            />
          </video>
        </div>
        <div className={styles.textContainerDown}>
          <p className={styles.textNext}>
            شمع رو فوت کن،بعدش رو هوایی! شیوه جشن توی هلیوم با همه جا فرق داره.
            ما اینجا برای بچه ها یه جشن تولد پر از بازی و هیجان برنامه ریزی
            می‌کنیم.دور میز نشستن،خوردن کیک و غذا سرجاش ولی بعدش نوبت بازیه.
            راستی توی اینجا اتاق تولد اختصاصی برای جشن های پرسروصدا و خودمونی هم
            داریم.
          </p>
        </div>
        <div className={styles.galleryContainer}>
          <img
            className={styles.image}
            src="https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/DSC06780.jpg"
            alt=""
          />
          <img
            className={styles.image}
            src="https://s9.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/_MG_4724-Edit.jpg"
            alt=""
          />
          <img
            className={styles.image}
            src="https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/DSC04773.jpg"
            alt=""
          />
        </div>
        <div className={styles.contactContainer}>
          <div className={styles.contact}>
            <h1 className={styles.contactTitle}>
              برای هماهنگی و اطلاعات بیشتر از اتاق تولد
              <br />
              با شماره ۰۹۰۲۰۰۳۱۴۳۹ تماس بگیرید.
            </h1>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default BirthdayPage;
